var _path, _rect, _rect2, _rect3, _rect4, _path2, _rect5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h900v600H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 179.031,
    y: 138.913,
    width: 588.237,
    height: 369.687,
    rx: 28,
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 630.851,
    y: 166.091,
    width: 63.943,
    height: 23.177,
    rx: 11.589,
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 544.79,
    y: 166.091,
    width: 63.943,
    height: 23.177,
    rx: 11.589,
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 499.495,
    y: 166.091,
    width: 23.177,
    height: 23.177,
    rx: 11.589,
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M252.553 381.315h79.058v28.953h33.296v-28.953h20.428v-27.908h-20.428v-107.85h-43.591L252.553 353.89v27.425zm79.701-27.908h-44.636v-1.287l43.349-68.602h1.287v69.889zm140.864 60.48c41.419 0 66.431-31.527 66.512-85.814.08-53.884-25.254-84.768-66.512-84.768-41.338 0-66.431 30.803-66.511 84.768-.161 54.126 25.012 85.733 66.511 85.814zm0-28.873c-18.899 0-31.124-18.98-31.044-56.941.081-37.397 12.225-56.217 31.044-56.217 18.739 0 30.964 18.82 30.964 56.217.08 37.961-12.144 56.941-30.964 56.941zm88.85-3.699h79.058v28.953h33.296v-28.953h20.428v-27.908h-20.428v-107.85h-43.591L561.968 353.89v27.425zm79.701-27.908h-44.636v-1.287l43.349-68.602h1.287v69.889z",
    fill: "#E1E4E5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 216.399,
    y: 166.091,
    width: 18.648,
    height: 18.648,
    rx: 9.324,
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 11.833,
    transform: "matrix(1 0 0 -1 186.698 399.545)",
    fill: "#666AF6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 16.569,
    transform: "scale(-1 1) rotate(30 -842.37 -1310.527)",
    fill: "#666AF6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 12.349,
    transform: "matrix(-1 0 0 1 466.813 177.572)",
    fill: "#E1E4E5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 319.16,
    cy: 131.833,
    r: 16.435,
    fill: "#666AF6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 554.114,
    cy: 443.789,
    transform: "rotate(180 554.114 443.789)",
    fill: "#666AF6",
    r: 13.589
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 12.49,
    transform: "matrix(-1 0 0 1 302.76 469.868)",
    fill: "#E1E4E5"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 9.36,
    transform: "scale(1 -1) rotate(-30 -593.95 -1005.323)",
    fill: "#E1E4E5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 718.31,
    y: 181.625,
    width: 27.252,
    height: 3.175,
    rx: 1.588,
    transform: "rotate(-45 718.31 181.625)",
    fill: "#E1E4E5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 728.759,
    y: 181.7,
    width: 10.119,
    height: 3.175,
    rx: 1.588,
    transform: "rotate(-45 728.759 181.7)",
    fill: "#E1E4E5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 195.148,
    y: 480.282,
    width: 24.384,
    height: 2.841,
    rx: 1.42,
    transform: "rotate(-45 195.148 480.282)",
    fill: "#E1E4E5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 204.497,
    y: 480.348,
    width: 9.054,
    height: 2.841,
    rx: 1.42,
    transform: "rotate(-45 204.497 480.348)",
    fill: "#E1E4E5"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 168.95,
    y: 136.396,
    width: 47.139,
    height: 5.492,
    rx: 2.746,
    transform: "rotate(135 168.95 136.396)",
    fill: "#E1E4E5"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 150.878,
    y: 136.267,
    width: 17.503,
    height: 5.492,
    rx: 2.746,
    transform: "rotate(135 150.878 136.267)",
    fill: "#E1E4E5"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 744.509,
    y: 462.467,
    width: 33.185,
    height: 3.866,
    rx: 1.933,
    transform: "rotate(135 744.509 462.467)",
    fill: "#E1E4E5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 731.786,
    y: 462.377,
    width: 12.322,
    height: 3.866,
    rx: 1.933,
    transform: "rotate(135 731.786 462.377)",
    fill: "#E1E4E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M708.429 102.773h3.304c.799 0 1.442.65 1.442 1.442v3.304c0 .799-.65 1.442-1.442 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304a1.439 1.439 0 0 1 1.442-1.442zm11.455 0h3.304c.792 0 1.442.65 1.442 1.442v3.304c0 .799-.65 1.442-1.442 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304c0-.792.65-1.442 1.442-1.442zm11.463 0h3.304c.793 0 1.443.65 1.443 1.442v3.304c0 .799-.65 1.442-1.443 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304a1.439 1.439 0 0 1 1.442-1.442zm11.456 0h3.304c.792 0 1.442.65 1.442 1.442v3.304c0 .799-.65 1.442-1.442 1.442h-3.304a1.45 1.45 0 0 1-1.449-1.442v-3.304a1.458 1.458 0 0 1 1.449-1.442zm11.456 0h3.304c.799 0 1.449.65 1.449 1.442v3.304c0 .799-.65 1.442-1.449 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304c0-.792.65-1.442 1.442-1.442zm-33.955 12.492h3.304c.793 0 1.443.65 1.443 1.442v3.311c0 .792-.65 1.442-1.443 1.442h-3.304c-.799 0-1.442-.65-1.442-1.442v-3.304a1.44 1.44 0 0 1 1.442-1.449zm11.456 0h3.304c.792 0 1.442.65 1.442 1.442v3.311c0 .792-.65 1.442-1.442 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304a1.44 1.44 0 0 1 1.442-1.449zm11.456 0h3.304c.799 0 1.449.65 1.449 1.442v3.311a1.45 1.45 0 0 1-1.449 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304c0-.799.65-1.449 1.442-1.449zm-11.869-25.912h3.304c.793 0 1.443.65 1.443 1.442V94.1c0 .798-.65 1.442-1.443 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.305a1.439 1.439 0 0 1 1.442-1.442zm11.456 0h3.304c.792 0 1.442.65 1.442 1.442V94.1c0 .798-.65 1.442-1.442 1.442h-3.304a1.45 1.45 0 0 1-1.449-1.442v-3.305a1.458 1.458 0 0 1 1.449-1.442zm-631.14 402.96h3.304c.799 0 1.442.65 1.442 1.442v3.304c0 .799-.65 1.442-1.442 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304a1.439 1.439 0 0 1 1.442-1.442zm11.455 0h3.304c.793 0 1.443.65 1.443 1.442v3.304c0 .799-.65 1.442-1.443 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304c0-.792.65-1.442 1.442-1.442zm11.463 0h3.305c.792 0 1.442.65 1.442 1.442v3.304c0 .799-.65 1.442-1.442 1.442h-3.305c-.792 0-1.442-.65-1.442-1.442v-3.304a1.44 1.44 0 0 1 1.442-1.442zm11.456 0h3.304c.792 0 1.442.65 1.442 1.442v3.304c0 .799-.65 1.442-1.442 1.442h-3.304a1.45 1.45 0 0 1-1.449-1.442v-3.304a1.458 1.458 0 0 1 1.449-1.442zm11.456 0h3.304c.799 0 1.449.65 1.449 1.442v3.304c0 .799-.65 1.442-1.449 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304c0-.792.65-1.442 1.442-1.442zm-33.954 12.492h3.304c.792 0 1.442.65 1.442 1.442v3.311c0 .792-.65 1.442-1.442 1.442h-3.304c-.799 0-1.443-.65-1.443-1.442v-3.304a1.442 1.442 0 0 1 1.443-1.449zm11.455 0h3.304c.792 0 1.442.65 1.442 1.442v3.311c0 .792-.65 1.442-1.442 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304a1.44 1.44 0 0 1 1.442-1.449zm11.456 0h3.304c.799 0 1.449.65 1.449 1.442v3.311a1.45 1.45 0 0 1-1.449 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304c0-.799.65-1.449 1.442-1.449zm-11.868-25.912h3.304c.792 0 1.442.65 1.442 1.443v3.304c0 .799-.65 1.442-1.442 1.442h-3.304c-.793 0-1.443-.65-1.443-1.442v-3.304a1.44 1.44 0 0 1 1.443-1.443zm11.455 0h3.304c.792 0 1.442.65 1.442 1.443v3.304c0 .799-.65 1.442-1.442 1.442h-3.304a1.45 1.45 0 0 1-1.449-1.442v-3.304a1.458 1.458 0 0 1 1.449-1.443z",
    fill: "#E1E4E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.882 325.922c-24.64 0-44.617-20.259-44.617-45.246 0-24.987 19.977-45.245 44.617-45.245 24.64 0 44.617 20.258 44.617 45.245s-19.977 45.246-44.617 45.246z",
    fill: "#666AF6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m198.857 261.476-18.848 20.109-11.316-12.064",
    stroke: "#fff",
    strokeWidth: 7.405,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m161.178 300.835 18.848-20.109 11.316 12.064",
    stroke: "#fff",
    strokeWidth: 7.405,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.df8bafa81dc622086ed87ac5955b0735.svg";
export { ForwardRef as ReactComponent };